export const FIELD_PRESET_TYPE_MOBILE_COMPARISON = 'mobile';
export const FIELD_PRESET_TYPE_FULL = 'info-full';
export const FIELD_PRESET_TYPE_MEDIA_ONLY = 'media';
export const FIELD_PRESET_TYPE_REFERENCE_COMPARISON = 'reference-comparison';
export const FIELD_PRESET_TYPE_MOBILE_REFERENCE_COMPARISON = 'mobile-reference-comparison';
export const FIELD_PRESET_TYPE_SOLUTIONS = 'solutions';
export const FIELD_PRESET_TYPE_SOLUTIONS_MEDIA_ONLY = 'solutions-media';
